import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Routes, Route, Navigate, useParams } from 'react-router';
import { getTabLabelByLink, tabLowerCase } from '@/helpers/utils';
import useAppLanguage from '@/hooks/useAppLanguage';
import titleService from '@/services/titleService';
import AffectedVehiclesFieldsMaintenance from './AffectedVehiclesFieldsMaintenance/AffectedVehiclesFieldsMaintenance';
import DescriptionFieldsMaintenance from './DescriptionFieldsMaintenance/DescriptionFieldsMaintenance';

const FieldsMaintenance = () => {
  const { t } = useTranslation();
  const lang = useAppLanguage();
  const { fieldsTab } = useParams();

  useEffect(() => {
    const tab = `navTab.${getTabLabelByLink(tabLowerCase(fieldsTab))}`;
    titleService.updatePageTitle(t('dashboard.administration'), `${t('administration.fields')} - ${t(tab)}`);
  }, [t, fieldsTab, lang]);

  return (
    <Routes>
      <Route path="description" element={<DescriptionFieldsMaintenance />} />
      <Route path="affected-vehicles" element={<AffectedVehiclesFieldsMaintenance />} />
      <Route path="*" element={<Navigate to="description" replace />} />
    </Routes>
  );
};

export default FieldsMaintenance;
